import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import axios from 'axios';

const ProfileMenu = ({ profileImage, refreshProfile }) => {
  const [open, setOpen] = useState(false);
  const [student, setStudent] = useState(null);
  const [localProfileImage, setLocalProfileImage] = useState(null);
  const navigate = useNavigate();

  // Fetch student profile data
  const fetchStudentProfile = async () => {
    try {
      const response = await axios.get('/api/MyAccountRoutes/profile', {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      
      const profileData = response.data;
      setStudent(profileData);

      // Handle profile photo if not passed as prop
      if (!profileImage && (profileData.profilePhoto || profileData.profilePhotoUrl)) {
        const photoUrl = profileData.profilePhotoUrl || 
          `${window.location.origin}/api/MyAccountRoutes${profileData.profilePhoto}`;
        
        const img = new Image();
        img.onload = () => {
          setLocalProfileImage(photoUrl);
        };
        img.onerror = () => {
          setLocalProfileImage(null);
        };
        img.src = photoUrl;
      }
    } catch (error) {
      console.error('Error fetching student profile in menu:', error);
      // Fallback to localStorage
      const storedStudent = localStorage.getItem('student');
      if (storedStudent) {
        setStudent(JSON.parse(storedStudent));
      }
    }
  };

  useEffect(() => {
    fetchStudentProfile();
  }, []);

  // Use profileImage prop if available, otherwise use local state
  const displayImage = profileImage || localProfileImage;

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('student');
    localStorage.removeItem('user');
    navigate('/student-login');
  };

  const handleNavigation = (path) => {
    setOpen(false);
    navigate(path);
  };

  if (!student) return null;

  const ProfilePhoto = ({ size = '40px', style = {} }) => {
    if (displayImage) {
      return (
        <img
          src={displayImage}
          alt="Student Profile"
          style={{
            borderRadius: '50%',
            width: size,
            height: size,
            objectFit: 'cover',
            border: '2px solid #e5e7eb',
            ...style
          }}
          onError={() => {
            if (refreshProfile) refreshProfile();
            setLocalProfileImage(null);
          }}
        />
      );
    } else {
      return (
        <div
          style={{
            borderRadius: '50%',
            width: size,
            height: size,
            backgroundColor: '#6366f1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: size === '40px' ? '16px' : '14px',
            fontWeight: '600',
            border: '2px solid #e5e7eb',
            ...style
          }}
        >
          {student.fullName ? student.fullName.charAt(0).toUpperCase() : 'S'}
        </div>
      );
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '0.3rem',
          borderRadius: '12px',
          backgroundColor: '#ffffff',
          color: '#1f2937',
          transition: 'background-color 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#f9fafb';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#ffffff';
        }}
      >
        <ProfilePhoto style={{ marginRight: '8px' }} />
        <div>
          <div style={{ fontWeight: '600', fontSize: '1rem' }}>
            {student.fullName || 'Student'}
          </div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>Student</div>
        </div>
      </div>

      {open && (
        <>
          {/* Overlay to close menu when clicking outside */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
            }}
            onClick={() => setOpen(false)}
          />
          
          <div
            style={{
              position: 'absolute',
              top: '70px',
              right: 0,
              width: '220px',
              background: '#fff',
              boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
              borderRadius: '16px',
              overflow: 'hidden',
              zIndex: 1000,
              border: '1px solid #e5e7eb',
            }}
          >
            {/* Profile Header */}
            <div style={{ padding: '15px', borderBottom: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ProfilePhoto style={{ marginRight: '12px' }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '600', fontSize: '1rem', color: '#111827' }}>
                    {student.fullName || 'Student'}
                  </div>
                  <div style={{ fontSize: '12px', color: '#6B7280' }}>
                    {student.email || 'Student'}
                  </div>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div style={{ padding: '8px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  padding: '12px',
                  borderRadius: '8px',
                  transition: 'background-color 0.2s ease',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#6B21A8',
                }}
                onClick={handleLogout}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3f4f6';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <FaSignOutAlt style={{ marginRight: '12px', color: '#6B21A8', fontSize: '16px' }} />
                Log out
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfileMenu;